import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { LoggerProvider, SimpleLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { CI_METRICS_OTEL_TOKEN, OTEL_COLLECTOR_URL, OTEL_SERVICE_NAME, SEMRESATTRS_SERVICE_NAME, } from './constants';
let logger;
let loggerProvider;
export const forceFlush = () => loggerProvider.forceFlush();
export const init = ({ exporterOptions, serviceName, otelUrl, otelToken, dryRun, customExporters, }) => {
    loggerProvider = new LoggerProvider({
        resource: new Resource({
            [SEMRESATTRS_SERVICE_NAME]: serviceName || OTEL_SERVICE_NAME,
        }),
    });
    const authorization = otelToken || CI_METRICS_OTEL_TOKEN
        ? {
            Authorization: `Bearer ${otelToken || CI_METRICS_OTEL_TOKEN}`,
        }
        : {};
    const headers = {
        ...(exporterOptions?.headers || {}),
        ...authorization,
    };
    const exporters = customExporters || [];
    if (!dryRun) {
        const OTLPExporter = new OTLPLogExporter({
            ...exporterOptions,
            url: `${otelUrl || OTEL_COLLECTOR_URL}/v1/logs`,
            headers,
        });
        exporters.push(OTLPExporter);
    }
    exporters.forEach((exporter) => loggerProvider.addLogRecordProcessor(new SimpleLogRecordProcessor(exporter)));
    logger = loggerProvider.getLogger(serviceName || OTEL_SERVICE_NAME);
};
export const destroy = () => {
    logger = undefined;
    return loggerProvider.shutdown();
};
export const emit = (attributes, message, severity) => {
    const { severityNumber, severityText } = severity;
    if (logger) {
        logger.emit({
            severityNumber,
            severityText,
            body: message,
            attributes,
        });
    }
};
//# sourceMappingURL=logs.js.map